import { create } from "zustand";

export type PayoutStatusFilterType =
  | "draft"
  | "payment_processing"
  | "paid"
  | "failed"
  | "all";

type SellarCreditFilterState = {
  status: PayoutStatusFilterType;
  setStatus: (status: PayoutStatusFilterType) => void;
  reset: () => void;
  setState: (state: SellarCreditFilterState) => void;
};

export const useSellarCreditFilterStore = create<SellarCreditFilterState>(
  (set) => ({
    status: "all",
    setStatus: (status) => set({ status }),
    reset: () => set({ status: "all" }),
    setState: (state) => set(state),
  }),
);
